import JWTDecode from 'jwt-decode';
import env from '../../config/env';
import { makeRequest } from './xhr';

interface IToken {
  access_token: string;
  expires_in: string;
  id_token: string;
  token_type: string;
}

interface IJWT {
  uid: string;
  exp: number;
  isMemberOf: string;
  // there are more unused properties
}

const allSalesOrgs = [
  'AT01',
  'BE01',
  'LU01',
  'NL01',
  'FR01',
  'CA48',
  'CN04',
  'DE01',
  'EG12',
  'HK02',
  'IN02',
  'ID01',
  'MO02',
  'IT15',
  'NL29',
  'MY05',
  'MY08',
  'PL03',
  'RU05',
  'SG01',
  'ZA03',
  'ES01',
  'CH01',
  'GB30',
  'TR04',
  'BM23',
  'GB01',
  'US52',
];

const marineSalesOrgs = ['SG88', 'US86'];

class AuthClient {
  // TODO convert this back to private
  public token: IToken | null = null;
  public userSalesOrgIDs: string[] = [];

  public isLoggedIn() {
    // TODO check expiry date etc
    return !!this.token;
  }

  public getAccessToken() {
    if (!this.isLoggedIn()) {
      return null;
    }
    return this.token!.access_token;
  }

  public requestAuthorisationURL() {
    return `${env.auth.host}?client_id=${env.auth.clientId}&response_type=${env.auth.response_type}&redirect_uri=${env.auth.redirect_uri}&state=${env.auth.state}&code_challenge=${env.auth.code_challenge}&code_challenge_method=S256&scope=${env.auth.scope}`;
  }

  public async requestClientSalesOrg(
    token: string
  ): Promise<{ value: string[] }> {
    const payload = {
      groupIds: env.auth.groupIds,
    };
    const data = JSON.stringify(payload);

    const response = await makeRequest(
      env.auth.introspect,
      'POST',
      {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
      data
    );
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    return response.json();
  }

  public async requestAccessToken(code: string) {
    const body = new URLSearchParams();
    body.append('client_id', env.auth.clientId);
    body.append('code', code);
    body.append('code_verifier', env.auth.code_verifier);
    body.append('grant_type', 'authorization_code');
    body.append('redirect_uri', env.auth.redirect_uri);
    const payload = await fetch(env.auth.gettoken, {
      body,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      method: 'POST',
      mode: 'cors',
    }).then(res => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error(res.statusText);
      }
    });
    this.token = payload;
    /*const isAllowedUser = await isAllowed(payload.access_token);
    if (!isAllowedUser) {
      history.push(UNAUTHORISED_PAGE_ROUTE, { from: history.location });
    }*/
  }

  public getUserSalesOrgs(): string[] {
    const getUserGroups = this.decodeJWT();
    if (getUserGroups?.isMemberOf) {
      if (
        getUserGroups?.isMemberOf.includes(env.auth.regionsMemberGroupMap.OM02)
      ) {
        return ['OM02'];
      }
      if (
        getUserGroups?.isMemberOf.includes(env.auth.regionsMemberGroupMap.PH01)
      ) {
        return ['PH01'];
      }
      if (
        getUserGroups?.isMemberOf.includes(env.auth.regionsMemberGroupMap.PK01)
      ) {
        return ['PK01'];
      }
      if (
        getUserGroups?.isMemberOf.includes(
          env.auth.regionsMemberGroupMap.MARINE
        )
      ) {
        if (
          getUserGroups?.isMemberOf.includes(
            env.auth.regionsMemberGroupMap.MARINE
          ) &&
          (getUserGroups?.isMemberOf.includes(env.auth.groupIds[0]) ||
            getUserGroups?.isMemberOf.includes(env.auth.groupIds[1]) ||
            getUserGroups?.isMemberOf.includes(env.auth.groupIds[2]))
        ) {
          return [...allSalesOrgs, ...marineSalesOrgs];
        } else {
          return marineSalesOrgs;
        }
      }
      return allSalesOrgs;
    }
    return [''];
  }

  public getUserID() {
    const decodedJWT = this.decodeJWT();

    if (!decodedJWT) {
      return null;
    }
    return decodedJWT.uid;
  }

  public isTokenExpired() {
    if (!this.token) {
      return true;
    }
    const expiryTime = this.decodeJWT();
    if (!expiryTime) {
      return null;
    }
    const date = new Date(expiryTime.exp * 1000);
    return date.getTime() < Date.now();
  }

  private decodeJWT(): IJWT | null {
    const accessToken = this.getAccessToken();

    if (!accessToken) {
      return null;
    }
    return JWTDecode(accessToken);
  }
}

export default AuthClient;
